import {SET_COMMENTS, READ_COMMENTS} from '../constants/comments';

const initialState = {
  comments: [],
  sortKey: null,
  sortType: null,
};

const commentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMMENTS:
      return {
        ...state,
        comments: [...action.comments]
      };
    case READ_COMMENTS:
      return {
        ...state,
        comments: state.comments.map(c => {if (action.ids.includes(c.id)) c.read=true; return c}),
      };
    default:
      return state;
  }
};

export default commentsReducer;